(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ad-faq')) {
    class AdFaq extends HTMLElement {
      connectedCallback() {
        this.search = this.querySelector('[data-ad-faq-search]');
        this.items = [...this.querySelectorAll('[data-ad-faq-item]')];
        this.cats = [...this.querySelectorAll('[data-ad-faq-cat]')];
        this.empty = this.querySelector('[data-ad-faq-empty]');
        this.status = this.querySelector('[data-ad-faq-status]');
        this.category = '';
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.search?.addEventListener('input', () => this.filter(), { signal });
        for (const cat of this.cats) {
          cat.addEventListener(
            'click',
            () => {
              this.category = cat.dataset.adFaqCat;
              for (const other of this.cats) {
                other.setAttribute('aria-pressed', String(other === cat));
              }
              this.filter();
            },
            { signal }
          );
        }

        const dialog = this.querySelector('[data-ad-faq-dialog]');
        const dialogImg = this.querySelector('[data-ad-faq-dialog-img]');
        for (const thumb of this.querySelectorAll('[data-ad-faq-zoom]')) {
          thumb.addEventListener(
            'click',
            () => {
              dialogImg.src = thumb.dataset.adFaqZoom;
              dialogImg.alt = thumb.dataset.alt || '';
              dialog.showModal();
              this.lastThumb = thumb;
            },
            { signal }
          );
        }
        this.querySelector('[data-ad-faq-close]')?.addEventListener('click', () => dialog.close(), { signal });
        dialog?.addEventListener('click', (event) => event.target === dialog && dialog.close(), { signal });
        dialog?.addEventListener('close', () => this.lastThumb?.focus(), { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      filter() {
        const term = (this.search?.value || '').trim().toLowerCase();
        let shown = 0;
        for (const item of this.items) {
          const matchesCat = !this.category || item.dataset.category === this.category;
          const matchesText = !term || item.textContent.toLowerCase().includes(term);
          const visible = matchesCat && matchesText;
          item.hidden = !visible;
          if (visible) shown++;
        }
        if (this.empty) this.empty.hidden = shown !== 0;
        if (this.status) {
          const template = this.querySelector(shown === 1 ? '[data-ad-faq-count-one]' : '[data-ad-faq-count-many]');
          const text = template?.content.textContent || template?.textContent || '';
          this.status.textContent = '';
          requestAnimationFrame(() => {
            this.status.textContent = text.replace('__count__', shown);
          });
        }
      }
    }

    customElements.define('ad-faq', AdFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
